import React, { useState } from 'react'
import {
  TextField,
  Select,
  RadioButton,
  Checkbox,
  Label,
} from '@shopify/polaris'
import i18n from '../../translations/i18n'
import moment from 'moment'

let availableFields = [
  'text',
  'email',
  'date',
  'date-time',
  'dropdown',
  'multi-select',
]

function AnswerCustomFields(props) {
  const { t } = i18n
  const changeValue = (c, value) => {
    let tempCfV = { ...props.customFieldsValues }
    tempCfV[c.id] = value
    props.setCustomFieldsValues(tempCfV)
  }

  const checkAllFieldsEntered = () => {
    if (!!props.customFields) {
      let rf = props.customFields.filter((c) => {
        return c.required && availableFields.includes(c.cf_type)
      })

      if (rf.length > 0) {
        let entered = true
        rf.map((r) => {
          if (!props.customFieldsValues[r.id]) {
            entered = false
          }
        })
        props.setAllFieldsEntered(entered)
      } else {
        props.setAllFieldsEntered(true)
      }
    }
  }

  checkAllFieldsEntered()

  const getViewByType = (c) => {
    let label = `${c.label} ${c.required ? `*` : ''}`
    switch (c.cf_type) {
      case 'text':
        return (
          <TextField
            label={label}
            onChange={(value) => {
              changeValue(c, value)
            }}
            value={props.customFieldsValues[c.id]}
          />
        )
      case 'email':
        return (
          <TextField
            label={label}
            onChange={(value) => {
              changeValue(c, value)
            }}
            value={props.customFieldsValues[c.id]}
          />
        )
      case 'dropdown':
        return (
          <Select
            label={label}
            options={[
              { label: '', value: null },
              ...c.options.map((o) => ({ label: o, value: o })),
            ]}
            onChange={(value) => {
              changeValue(c, value)
            }}
            value={props.customFieldsValues[c.id]}
          />
        )
      case 'radio':
        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Label>{label}</Label>
            {c.options.map((o, i) => {
              return (
                <RadioButton
                  label={o}
                  checked={props.customFieldsValues[c.id] === o}
                  id={`${o}_${c.id}`}
                  name={`${o}_${c.id}`}
                  onChange={(_, newValue) => {
                    console.log('newValue', newValue)
                    let values = newValue.split('_')
                    if (values.length > 0) {
                      let finalValue = values[0]
                      changeValue(c, finalValue)
                    }
                  }}
                />
              )
            })}
          </div>
        )
      case 'multi-select':
        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Label>{label}</Label>
            {c.options.map((o) => {
              let checked = false
              if (props.customFieldsValues[c.id]) {
                let arr = props.customFieldsValues[c.id].split(',')
                checked = !!arr.find((a) => a === o)
              }

              return (
                <Checkbox
                  label={o}
                  checked={checked}
                  onChange={(newChecked) => {
                    let values = ''
                    if (newChecked) {
                      if (!!props.customFieldsValues[c.id]) {
                        values = `${props.customFieldsValues[c.id]},${o}`
                      } else {
                        values = o
                      }
                    } else {
                      let arr = props.customFieldsValues[c.id].split(',')
                      values = arr.filter((a) => a !== o).join(',')
                    }
                    changeValue(c, values)
                  }}
                />
              )
            })}
          </div>
        )
      case 'date':
        return (
          <div
            ref={(el) => {
              if (el && window.flatpickr) {
                const input = el.querySelector('input')
                if (
                  input &&
                  !input.classList.contains('flatpickr-initialized')
                ) {
                  window.flatpickr(input, {
                    dateFormat: 'Y-m-d H:i',
                    defaultDate: props.customFieldsValues[c.id] || null,
                    onChange: (dates) => {
                      const selectedDate = dates[0]
                      changeValue(
                        c,
                        selectedDate
                          ? moment(selectedDate).format('YYYY-MM-DD')
                          : ''
                      )
                    },
                  })
                  input.classList.add('flatpickr-initialized')
                }
              }
            }}
          >
            <TextField
              label={label}
              value={props.customFieldsValues[c.id] || ''}
              placeholder="Select date and time..."
            />
          </div>
        )

      case 'date-time':
        return (
          <div
            ref={(el) => {
              if (el && window.flatpickr) {
                const input = el.querySelector('input')
                if (
                  input &&
                  !input.classList.contains('flatpickr-initialized')
                ) {
                  window.flatpickr(input, {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    defaultDate: props.customFieldsValues[c.id] || null,
                    onChange: (dates) => {
                      const selectedDate = dates[0]
                      changeValue(
                        c,
                        selectedDate
                          ? moment(selectedDate).format('YYYY-MM-DD HH:mm')
                          : ''
                      )
                    },
                  })
                  input.classList.add('flatpickr-initialized')
                }
              }
            }}
          >
            <TextField
              label={label}
              value={props.customFieldsValues[c.id] || ''}
              placeholder="Select date and time..."
            />
          </div>
        )
    }
  }

  return (
    <div>
      {!props.allFieldsEntered && (
        <p style={{ margin: props.fromView ? '20px 0px' : 20, color: 'red' }}>
          {t('please-enter-all-the-fields')}
        </p>
      )}
      {!!props.customFields &&
        props.customFields.map((c) => {
          return (
            <div style={{ margin: props.fromView ? '20px 0px' : 20 }}>
              {getViewByType(c)}
            </div>
          )
        })}
    </div>
  )
}

export default AnswerCustomFields
